import { render } from "./VentasCrear.vue?vue&type=template&id=cd796f00&scoped=true"
import script from "./VentasCrear.vue?vue&type=script&lang=js"
export * from "./VentasCrear.vue?vue&type=script&lang=js"

import "./VentasCrear.vue?vue&type=style&index=0&id=cd796f00&lang=scss&scoped=true"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd796f00"]])

export default __exports__